import React from 'react'
import Like from '../../../../assets/images/like.svg';
import Dislike from '../../../../assets/images/dislike.svg';
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Table } from './ListCommentTable';
import { Doughnut } from 'react-chartjs-2';

export default function ListComment(props) {
    const { comments, commentsStats, showDeleteConfirm, showComment } = props;

    return (
        <>
            <DetaComment comments={comments} showDeleteConfirm={showDeleteConfirm} showComment={showComment} commentsStats={commentsStats} />
        </>
    )
}

function DetaComment(props) {
    const { comments, showDeleteConfirm, showComment, commentsStats } = props;

    return (
        <>
            <div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-10">
                            <div className="row mt-3">
                                <Table data={comments} onClickEliminar={showDeleteConfirm} onClickEditar={showComment} />
                            </div>
                        </div>
                        <div className="col-2">
                            <div className="row mt-3">
                                <div className="col-12 p-0 card">
                                    <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Categoría y Etiqueta más Utilizada</h6>
                                    </div>
                                    <div className="card-body p-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <label>
                                                    <strong>Etiqueta:</strong> 
                                                    <span className="badge badge-info ml-1">
                                                        {commentsStats && commentsStats.top_tag && commentsStats.top_tag.nm_etiqueta ? (
                                                            commentsStats.top_tag.nm_etiqueta
                                                        ) : (
                                                            ''
                                                        )}
                                                    </span>
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <label>
                                                    <strong>Categoría:</strong>
                                                    <span className="ml-1">
                                                        {commentsStats && commentsStats.top_category && commentsStats.top_category.nm_categoria ? (
                                                            commentsStats.top_category.nm_categoria
                                                        ) : (
                                                            ''
                                                        )}
                                                    </span></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 p-0 card">
                                    <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Like & Dislike (General)</h6>
                                    </div>
                                    <div className="card-body pt-3">
                                        <div className="row">
                                            <div className="col-6">
                                                <img src={Like} height="30" className="mr-3" alt="" />{commentsStats && commentsStats.likes ? (commentsStats.likes) : ''}
                                            </div>
                                            <div className="col-6">
                                                <img src={Dislike} height="30" className="mr-3" alt="" />{commentsStats && commentsStats.dislikes ? (commentsStats.dislikes) : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-12 p-0 card">
                                    <div className="card-header py-3">
                                    <h6 className="m-0 font-weight-bold text-primary">Total Visitas</h6>
                                    </div>
                                    <div className="card-body pt-3">
                                        <div className="row">
                                            <div className="col-12 text-center">
                                            <FontAwesomeIcon className="fa fa-eye text-success" icon={faEye} /> {commentsStats && commentsStats.visits ? (commentsStats.visits) : ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-xl-12 p-0">
                                    <div className="card shadow mb-4">
                                        <div className="card-header py-3">
                                            <h6 className="m-0 font-weight-bold text-primary">Estadística</h6>
                                        </div>
                                        <div className="card-body">
                                            <Chart commentsStats={commentsStats} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

function Chart(props) {
    const { commentsStats } = props;

    const state = {
        labels: ['Likes', 'Dislikes', 'Visitas'],
        datasets: [
          {
            label: 'Rainfall',
            backgroundColor: [
              '#4e73df',
              '#1cc88a',
              '#36b9cc'
            ],
            hoverBackgroundColor: [
            '#2e59d9',
            '#17a673',
            '#2c9faf'
            ],
            hoverBorderColor: "rgba(234, 236, 244, 1)",
            data: [commentsStats.likes, commentsStats.dislikes, commentsStats.visits]
          }
        ]
    }

        return(
            <>
                <Doughnut
                    data={state}
                    options= {{
                        maintainAspectRatio: false,
                        tooltips: {
                          backgroundColor: "rgb(255,255,255)",
                          bodyFontColor: "#858796",
                          borderColor: '#dddfeb',
                          borderWidth: 1,
                          xPadding: 15,
                          yPadding: 15,
                          displayColors: false,
                          caretPadding: 10,
                        },
                        legend: {
                          display: false
                        },
                        cutoutPercentage: 80,
                      }}
                    />
            </>
        )
}
